// default theme preset

export const theme = {
  name: "default",
  breakpoints: ["50em", "100em", "140em"],
  colors: {
    text: "#2D3F47",
    background: "#fff",
    primary: "#3F90B5",
    secondary: "#2A6C8A",
    muted: "#F4F9FF",
    gray: "#dddddf",
    highlight: "hsla(205, 100%, 40%, 0.125)",
    danger: "#F2542D",
    warn: "#F2BB2D",
    darkBlue: "#2D3F47",
  },
  fonts: {
    body: "system-ui, sans-serif",
    heading: "inherit",
    monospace: "Menlo, monospace",
  },
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 96],
  fontWeights: {
    body: 400,
    heading: 700,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.25,
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  sizes: {
    avatar: 48,
  },
  radii: {
    default: 4,
    circle: 99999,
  },
  shadows: {
    card: "0 0 10px rgba(0, 0, 0, .12)",
  },
  // rebass variants
  text: {
    color: "primary",
    heading: {
      fontFamily: "heading",
      lineHeight: "heading",
      fontWeight: "heading",
    },
    display: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading",
      fontSize: [5, 6, 7],
    },
    caps: {
      textTransform: "uppercase",
      letterSpacing: "0.1em",
    },
  },
  label: {
    fontWeight: "heading",
    fontSize: 1,
    color: "#2D3F47",
  },
  variants: {
    avatar: {
      width: "avatar",
      height: "avatar",
      borderRadius: "circle",
    },
    muted: {
      borderRadius: "15px",
    },
    card: {
      p: 2,
      bg: "background",
      boxShadow: "card",
      borderRadius: "default",
      margin: "3",
    },
    selectableCard: {
      variant: "variants.card",
      border: "solid 3px",
      borderColor: "background",
    },
    selectedCard: {
      variant: "variants.card",
      border: "solid 3px",
      borderColor: "primary",
    },
    link: {
      color: "primary",
    },
    nav: {
      fontSize: 1,
      fontWeight: "bold",
      display: "inline-block",
      p: 2,
      color: "inherit",
      textDecoration: "none",
      ":hover,:focus,.active": {
        color: "primary",
      },
    },
  },
  input: {
    maxWidth: "300px",
    width: "100%",
    marginBottom: 2,
    outline: "none",
    ":focus": {
      outlineColor: "primary",
    },
  },
  forms: {
    error: {
      borderStyle: "solid",
      borderColor: "danger",
      borderWidth: "2px",
    },
  },

  select: {
    marginBottom: 2,
  },
  buttons: {
    ":hover,:focus,:active": {
      outline: "",
    },
    primary: {
      cursor: "pointer",
      fontSize: 2,
      fontWeight: "bold",
      color: "background",
      bg: "primary",
      borderRadius: "default",
      outline: "",
      ":active": {
        transform: "translateY(1px)",
        outline: "",
      },
      ":focus": {
        outline: "none",
      },
      "&:disabled": {
        cursor: "auto",
        color: "white",
        bg: "gray",
      },
    },
    disabled: {
      variant: "buttons.primary",
      cursor: "auto",
      color: "white",
      bg: "gray",
      ":active": {
      },
      ":focus": {
      },
    },
    textButton: {
      variant: "buttons.primary",
      color: "primary",
      bg: "transparent",
    },
    secondary: {
      variant: "buttons.primary",
      color: "primary",
      bg: "white",
      borderStyle: "solid",
      borderWidth: "2px",
      borderColor: "primary",
    },
    danger: {
      variant: "buttons.primary",
      bg: "danger",
    },
  },
  styles: {
    root: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body",
    },
  },
};
